import { jsx } from "react/jsx-runtime";
import React from "react";
var star_filled_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "m12.0025 4 2.8593 4.9091 5.5524 1.2024-3.7852 4.2363L17.2012 20l-5.1987-2.2909L6.8038 20l.5723-5.6522-3.7853-4.2363 5.5524-1.2024L12.0025 4z" })];
};
export {
  star_filled_default as default
};
